import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import Banner from '../components/Banner';


function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">

      {/* --- Section Hero --- */}
      <section className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content fade-in">
            <Banner title="Bienvenue sur mon Portfolio !" />
            <h2>Je m'appelle <span className="highlight">Mathéo Teyssier</span>, 23 ans</h2>
            <p>
              Étudiant en BTS SIO (option SISR) et passionné par le réseau 
              ainsi que le développement.
            </p>
            <button 
              className="cta-button"
              onClick={() => navigate('/projets')}
            >
              Voir mes projets
            </button>
          </div>
        </div>
      </section>

      {/* --- Section À propos --- */}
      <section className="about-section fade-in">
        <h2>À propos de moi</h2>

        <div className="about-subsection">
          <h3>Présentation Perso</h3>
          <p>
            Passionné de nouvelles technologies depuis toujours, 
            j’aime comprendre et maîtriser l’ensemble de la chaîne 
            informatique, du développement d’applications à la 
            configuration de serveurs.
          </p>
        </div>

        <div className="about-subsection">
          <h3>Présentation Pro</h3>
          <p>
            Actuellement, je travaille chez <strong>Quietec</strong>, 
            où je suis en apprentissage, j'interviens chez des clients,
            je fais de la maintenance, de la configuration de serveurs,
            de la mise en place de postes clients, de la gestion de
            réseaux et bien d'autres tâches, c'est une opportunité
            d'apprentissage incroyable et le milieu de travail est merveilleux.
          </p>
        </div>

        <div className="about-subsection">
          <h3>Expérience</h3>
          <p>
            J’ai commencé mon parcours par un BUT Informatique, 
            avec une spécialisation développement. Après ces deux ans, 
            j’ai bifurqué en BTS SIO (SISR) pour renforcer mes compétences 
            en réseau. Aujourd’hui, je mets ces connaissances en pratique 
            chez Quietec, tout en gardant un pied dans le dev pour mes projets perso.
          </p>
        </div>
      </section>

      {/* --- Section CV (lien de téléchargement + aperçu PDF) --- */}
      <section className="cv-section fade-in">
        <h2>Mon CV</h2>
        <p>
          Téléchargez mon CV au format PDF : 
          <a href="/CV.pdf" download className="cv-download-link"> cliquez ici</a>.
        </p>

        {/* Aperçu intégré : placez le fichier cv.pdf dans /public ou gérez un chemin adapté */}
        <div className="cv-preview">
          <iframe 
            src="/CV.pdf" 
            title="Aperçu CV" 
            className="cv-iframe"
          />
        </div>
      </section>

    </div>
  );
}

export default Home;
